module.exports = __webpack_public_path__ + "static/media/bg.3229c647.jpg";